var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nuxt-link',_vm._b({staticClass:"alcor-tab-link",attrs:{"to":_vm.localePath(_vm.to, _vm.$i18n.locale)}},'nuxt-link',_vm.$attrs,false),[_c('div',{staticClass:"inner"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }